export function getWorkorderComplementNumber(
  workorderNumber?: number,
  complementNumber?: number,
) {
  return `${String(workorderNumber).padStart(6, '0')}/${String(
    complementNumber,
  ).padStart(2, '0')}`;
}
